module.exports = __webpack_public_path__ + "static/media/chargesk.d34ef13d.webp";